export default "__VITE_ASSET__BuLh31pQ__"